import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';

import { DartsScoreboardStats } from '../../../../../scoreboards/models/scoreboard-stats';

@Component({
    selector: 'ms-my-bets-darts-stats-scoreboard',
    templateUrl: 'my-bets-darts-stats-scoreboard.html',
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false,
})
export class MyBetsDartsStatsScoreboardComponent {
    sitecoreEventDetails = inject(SitecoreEventDetailsConfig);

    vm = input.required<DartsScoreboardStats>();
}
